"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CharacterLimit = void 0;
var styled_1 = __importDefault(require("@emotion/styled"));
var react_1 = __importDefault(require("react"));
var getCharacterLimitText_1 = require("./getCharacterLimitText");
var Limit = styled_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  color: ", ";\n  font-size: 12px;\n  line-height: 1.7;\n"], ["\n  color: ", ";\n  font-size: 12px;\n  line-height: 1.7;\n"])), function (_a) {
    var color = _a.color;
    return color;
});
var CharacterLimit = function (props) { return (react_1.default.createElement(Limit, { className: props.className, color: props.color }, (0, getCharacterLimitText_1.getCharacterLimitText)(props))); };
exports.CharacterLimit = CharacterLimit;
var templateObject_1;
